// Header display only. Cart mutations remain owned by the existing theme.
export function installAtlasCartCount(doc, win) {
  const validCount = (value) => Number.isSafeInteger(value) && value >= 0;
  const links = () => [...doc.querySelectorAll('[data-atlas-cart-link]')];
  let revision = 0;
  let pendingRead = null;
  let queuedRead = false;
  let disposed = false;

  const paint = (count) => {
    if (!validCount(count) || disposed) return;
    for (const link of links()) {
      const label = link.querySelector('[data-atlas-cart-count]');
      if (!label) continue;
      label.textContent = ` (${count})`;
      label.hidden = count === 0;
    }
  };

  const reconcile = () => {
    if (disposed) return;
    if (pendingRead) {
      queuedRead = true;
      return;
    }
    const link = links()[0];
    if (!link) return;
    let url;
    try {
      url = new URL(link.href, win.location.href);
    } catch {
      return;
    }
    if (url.origin !== win.location.origin || !url.pathname.endsWith('/cart')) return;
    url.pathname += '.js';
    url.search = '';
    url.hash = '';
    const readRevision = revision;
    pendingRead = Promise.resolve()
      .then(() => win.fetch(url.href, {
        method: 'GET', credentials: 'same-origin', mode: 'same-origin',
        cache: 'no-store', redirect: 'error',
        headers: { Accept: 'application/json' },
      }))
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => {
        if (readRevision === revision && validCount(cart?.item_count)) paint(cart.item_count);
      })
      .catch(() => { /* Retain the last count on a failed read; never invent zero. */ })
      .finally(() => {
        pendingRead = null;
        if (queuedRead && !disposed) {
          queuedRead = false;
          reconcile();
        }
      });
  };

  const onCartUpdate = (event) => {
    if (event.detail?.data?.didError === true) return;
    revision += 1;
    const count = event.detail?.resource?.item_count;
    if (validCount(count)) {
      queuedRead = false;
      paint(count);
    } else {
      // product-form itemCount is an added quantity, not the cart's total.
      reconcile();
    }
  };
  const onPageShow = (event) => {
    if (!event.persisted) return;
    revision += 1;
    reconcile();
  };
  doc.addEventListener('cart:update', onCartUpdate);
  win.addEventListener('pageshow', onPageShow);
  return {
    dispose() {
      disposed = true;
      revision += 1;
      queuedRead = false;
      doc.removeEventListener('cart:update', onCartUpdate);
      win.removeEventListener('pageshow', onPageShow);
    },
  };
}

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  installAtlasCartCount(document, window);
}
